export default "__VITE_ASSET__JyBXTxPO__"